import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 24, alt, color, className, onClick }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <svg ref={ref} onClick={onClick} width={size} height={size} viewBox='0 0 30 30' fill='none' className={className}>
      <g>
        <path
          fill={fillColor}
          d='M30,18.3c0-2.683-1.878-5.024-4.674-6.291c0.165,0.585,0.26,1.189,0.277,1.809c0.279,0.166,0.549,0.345,0.801,0.54 c1.41,1.088,2.188,2.487,2.188,3.942c0,1.454-0.775,2.854-2.188,3.94c-1.547,1.193-3.627,1.851-5.856,1.851 c-1.503,0-2.938-0.3-4.188-0.859c-0.776,0.153-1.583,0.25-2.414,0.284c1.705,1.281,4.033,2.072,6.602,2.072 c1.649,0,3.199-0.324,4.548-0.897l3.441,1.756l-0.695-3.511C29.189,21.676,30,20.061,30,18.3z'
        />
        <path
          fill={fillColor}
          d='M24.624,12.837c-0.019-0.619-0.112-1.224-0.276-1.808c-1.201-4.274-6.133-7.476-12.034-7.476 C5.513,3.554,0,7.806,0,13.051c0,2.295,1.055,4.398,2.812,6.041l-0.906,4.572l4.483-2.287c1.758,0.746,3.777,1.172,5.925,1.172 c0.219,0,0.437-0.006,0.653-0.014c0.829-0.033,1.637-0.131,2.415-0.285c5.316-1.051,9.246-4.771,9.246-9.199 C24.627,12.98,24.626,12.909,24.624,12.837z M19.945,18.187c-1.867,1.438-4.33,2.28-6.993,2.396 c-0.211,0.011-0.424,0.016-0.639,0.016c-0.412,0-0.819-0.018-1.222-0.053c-2.438-0.204-4.679-1.023-6.408-2.357 c-1.837-1.417-2.849-3.241-2.849-5.136c0-1.895,1.012-3.719,2.849-5.136c2.015-1.554,4.725-2.41,7.63-2.41 c2.906,0,5.617,0.856,7.63,2.41c0.912,0.703,1.619,1.506,2.103,2.368c0.306,0.547,0.521,1.118,0.64,1.702 c0.071,0.351,0.107,0.707,0.107,1.065C22.793,14.946,21.782,16.77,19.945,18.187z'
        />
      </g>
      <g>
        <circle fill={fillColor} cx='16.682' cy='13.08' r='1.347' />
        <circle fill={fillColor} cx='12.314' cy='13.08' r='1.347' />
        <circle fill={fillColor} cx='7.946' cy='13.08' r='1.348' />
      </g>
    </svg>
  );
});

export default React.memo(Icon);
